/**
 * タスクが変わったことを画面横断で知らせる window event (steering 627)。
 *
 * ヘッダーの「自分のタスク」バッジ (`MyTasksBadge` / `useMyOpenTaskCount`) は一覧画面とは別の
 * 木にあるので、タスクの追加・編集・完了・再開・担当変更・削除のあとにこの event で読み直す。
 * `useTasks` / `useClientTasks` の mutation が成功したときに流す (失敗時は流さない)。
 */
export const TASKS_CHANGED_EVENT = 'acecollect:tasks-changed';

/** タスクが変わったことを知らせる。 */
export function notifyTasksChanged(): void {
  window.dispatchEvent(new Event(TASKS_CHANGED_EVENT));
}

/** mutation の `.then()` に挟む: 結果はそのまま返し、変更を知らせる。 */
export function afterTaskMutation<T>(result: T): T {
  notifyTasksChanged();
  return result;
}
